import React from 'react';
import CheckCircle from '@mui/icons-material/CheckCircle';
import { Box, CircularProgress, IconButton, Tooltip } from '@mui/material';

export type EmbeddedFormSaveButtonProps = {
  loading: boolean;
  /** Shown in tooltip and `aria-label` when not loading */
  idleTooltip: string;
  loadingTooltip?: string;
};

/**
 * Primary save/submit for forms shown in the right-hand drawer (same pattern as analytic profiles).
 */
export function EmbeddedFormSaveButton({
  loading,
  idleTooltip,
  loadingTooltip = 'Saving…',
}: EmbeddedFormSaveButtonProps) {
  const label = loading ? loadingTooltip : idleTooltip;
  return (
    <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end', gap: 1, alignItems: 'center' }}>
      <Tooltip title={label}>
        <span>
          <IconButton
            type="submit"
            disabled={loading}
            size="large"
            aria-label={label}
            sx={{
              bgcolor: '#60a5fa',
              color: '#0a0a0a',
              width: 56,
              height: 56,
              '&:hover': { bgcolor: '#3b82f6' },
              '&.Mui-disabled': { bgcolor: '#27272a', color: '#52525b' },
            }}
          >
            {loading ? (
              <CircularProgress size={28} thickness={4} sx={{ color: '#0a0a0a' }} />
            ) : (
              <CheckCircle sx={{ fontSize: 32 }} />
            )}
          </IconButton>
        </span>
      </Tooltip>
    </Box>
  );
}
